// @ts-nocheck
import { populate } from 'populate';
import type { Container, Graphics, Sprite } from 'pixi.js';
import { RaceEventTitleLocalizationsLayout } from './RaceEventTitleLocalizationsLayout';

const raw = {
  list: [
    {
      id: 'a36eb1ac-7508-4486-b2c3-eaf06ea62f4a',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '16ff8db8-619c-4107-8899-45160524551b',
      type: 'Graphics',
      name: 'darkOverlay',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'a36eb1ac-7508-4486-b2c3-eaf06ea62f4a',
      commands: []
    },
    {
      id: 'e4e43376-b968-4c0d-bb06-a6f3a518f4be',
      type: 'Container',
      name: 'wrapper',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'a36eb1ac-7508-4486-b2c3-eaf06ea62f4a'
    },
    {
      id: 'd2b4dfc6-aa08-455f-b50a-931104949259',
      type: 'Container',
      name: 'endSequenceSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'a36eb1ac-7508-4486-b2c3-eaf06ea62f4a'
    },
    {
      id: '207cff48-1fa6-409c-a94f-1cefe66466e7',
      type: 'Container',
      name: 'background',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e4e43376-b968-4c0d-bb06-a6f3a518f4be'
    },
    {
      id: 'bd57780f-4c01-435f-9c99-933ab6a3a56d',
      type: 'Container',
      name: 'centerSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e4e43376-b968-4c0d-bb06-a6f3a518f4be'
    },
    {
      id: '6938d60a-1776-4d91-b2c9-f02cfa9c3c12',
      type: 'Container',
      name: 'bottomSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e4e43376-b968-4c0d-bb06-a6f3a518f4be'
    },
    {
      id: '1e314206-160d-463b-8f7b-3150044ee2c3',
      type: 'Container',
      name: 'topSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e4e43376-b968-4c0d-bb06-a6f3a518f4be'
    },
    {
      id: '35c160cb-9bdd-4d24-bea4-c5023b1e80c8',
      type: 'Container',
      name: 'header',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e4e43376-b968-4c0d-bb06-a6f3a518f4be'
    },
    {
      id: '5df64169-4cef-4b92-88bb-c6e8845b2691',
      type: 'Sprite',
      name: 'backgroundGradient',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'WinStreak_Blue_Gradient',
      parent: '207cff48-1fa6-409c-a94f-1cefe66466e7'
    },
    {
      id: '0f971eb9-c25e-465e-a321-3b31e2479788',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 1,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Background_Left_Part',
      parent: '207cff48-1fa6-409c-a94f-1cefe66466e7'
    },
    {
      id: 'e259d9b1-e1ee-417e-aa67-70b7c69756e2',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Background_Right_Part',
      parent: '207cff48-1fa6-409c-a94f-1cefe66466e7'
    },
    {
      id: '5d14e99e-325c-4d48-9076-19b439e33bb0',
      type: 'Sprite',
      name: 'backgroundMirrorSide',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 1,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Background_Left_Part',
      parent: '207cff48-1fa6-409c-a94f-1cefe66466e7'
    },
    {
      id: '50fdbb39-f349-4511-b885-67dc084ac9ff',
      type: 'Container',
      name: 'titleWrapper',
      className: '',
      x: 0,
      y: 49,
      scale: {
        x: 0.8,
        y: 0.8
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '35c160cb-9bdd-4d24-bea4-c5023b1e80c8',
      data: {
        small: {
          y: 40,
          scaleXY: 0.5
        },
        big: {
          y: 109,
          scaleXY: 0.8
        }
      }
    },
    {
      id: 'eaa7be05-f6a4-4b2d-abf4-d08e9e817447',
      type: 'Sprite',
      name: 'helpButton',
      className: '',
      x: -285,
      y: 73,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Help_Button',
      parent: '35c160cb-9bdd-4d24-bea4-c5023b1e80c8'
    },
    {
      id: '3faac347-16dc-4a42-9823-a268756c8d6c',
      type: 'Sprite',
      name: 'closeButton',
      className: '',
      x: 285,
      y: 73,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -61,
        y: -73,
        width: 152,
        height: 139
      },
      texture: 'Close_Button',
      parent: '35c160cb-9bdd-4d24-bea4-c5023b1e80c8'
    },
    {
      id: '54cf914f-bf7d-41fe-858f-92ddef004101',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Event_Title_Back_Glow',
      parent: '50fdbb39-f349-4511-b885-67dc084ac9ff'
    },
    {
      id: '5f375f41-ba89-45f5-90a9-9af6875a5ebe',
      type: 'Layout',
      name: '',
      className: '',
      path: 'raceEvent/RaceEventTitleLocalizationsLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 22,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '50fdbb39-f349-4511-b885-67dc084ac9ff'
    }
  ],
  x: 0,
  y: 0,
  width: 780,
  height: 760,
  version: '2.0.0',
  handleResize: false
} as const;

export class RaceEventPopupLayout {
  static raw = raw;
  root!: Container;
  darkOverlay!: Graphics;
  wrapper!: Container;
  endSequenceSlot!: Container;
  background!: Container;
  centerSlot!: Container;
  bottomSlot!: Container;
  topSlot!: Container;
  header!: Container;
  backgroundGradient!: Sprite;
  backgroundMirrorSide!: Sprite;
  titleWrapper!: Container & { data: typeof raw['list'][13]['data'] };
  helpButton!: Sprite;
  closeButton!: Sprite;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
